<!-- Query Builder -->
<div id="{{name}}">
  <app-kv-ext-search *ngIf="showExtSearch && extSearchConfig" [query]="extSearchQuery" [config]="extSearchConfig"
    [openedAccordion]="openExtSearch" (extSearchReq)="sendExtSearchQuery($event)"></app-kv-ext-search>

  <div [ngSwitch]="layout" style="height: 100%" *ngIf="srvCalendar">

    <p-table *ngSwitchCase="standardLayout" #dt data-testid="dt" [columns]="cols" [value]="filteredData"
      [rowsPerPageOptions]="defaultRowsPerPageOptions" [paginator]="paginationType != noPagination && filteredData"
      [rows]="filter.limit" [totalRecords]="totalRecords" [lazy]="paginationType === 2" (onPage)="onPageChange($event)"
      (onSort)="onSortData($event)">

      <ng-template pTemplate="header" let-columns>

        <tr class="kontable-tr">
          <th *ngIf="showSelectButton">
            <div class="allowSelectCheckbox" (click)="onSelectAll()">
              <p-checkbox data-testid="selectAllRowsCheckBox" class="ch-checkbox" [binary]="true"
                [(ngModel)]="selectAllModel">
              </p-checkbox>
            </div>
          </th>
          <th *ngIf="expandTable" class="th-row-opener"></th>
          <th *ngFor="let col of columns" class="kontable-th field-{{col.field}}">
            <div *ngIf="!columnFiltersEnabled && !showExtSearch" class="kontable-col-title"
              [ngStyle]="{'justify-content': col.textAlignment == 'right' ? 'flex-end' : col.textAlignment}">
              <span>{{ col.title | translate }}</span>
            </div>

            <div *ngIf="(columnFiltersEnabled || showExtSearch) && col.sortable" class="kontable-col-title"
              [pSortableColumn]="col.field"
              [ngStyle]="{'justify-content': col.textAlignment == 'right' ? 'flex-end' : col.textAlignment}">
              <span>{{ col.title | translate }}</span>
              <p-sortIcon *ngIf="col.sortable" [field]="col.field"
                ariaLabel="{{ 'kontable.activateToSort' | translate }}"
                ariaLabelDesc="{{ 'kontable.activateToSortDescending' | translate }}"
                ariaLabelAsc="{{ 'kontable.activateToSortAscending' | translate }}"></p-sortIcon>
            </div>

            <div *ngIf="(columnFiltersEnabled || showExtSearch) && !col.sortable" class="kontable-col-title"
              [ngStyle]="{'justify-content': col.textAlignment == 'right' ? 'flex-end' : col.textAlignment}">
              <span>{{ col.title | translate }}</span>
            </div>

            <div *ngIf="col.searchable && columnFiltersEnabled">
              <div [ngSwitch]="col.filterType">
                <input [attr.data-testid]="'filter_for_' + col.field" *ngSwitchCase="textFilter" pInputText type="text"
                  (input)="updateTableFilter(col.field, $event.target.value, 'contains', col.filterChars)"
                  [(ngModel)]="filter.search[col.field]" [maxlength]="col.maxFilterChars"
                  (keyup.enter)="globalFilterChange($event.target.value)">
                <input [attr.data-testid]="'filter_for_' + col.field" *ngSwitchCase="numberFilter" pInputText
                  type="number" min="0"
                  (input)="updateTableFilter(col.field, $event.target.value, 'contains', col.filterChars)"
                  [(ngModel)]="filter.search[col.field]" (keyup.enter)="globalFilterChange($event.target.value)">
                <p-dropdown [attr.data-testid]="'filter_for_' + col.field" *ngSwitchCase="selectFilter"
                  [options]="col.filterOptions.values" [style]="{'width':'100%'}"
                  (onChange)="updateTableFilter(col.field, $event.value, 'equals', col.filterChars)"
                  [(ngModel)]="filter.search[col.field]"
                  (keyup.enter)="globalFilterChange($event.target.value)"></p-dropdown>
                <p-multiSelect [attr.data-testid]="'filter_for_' + col.field" *ngSwitchCase="multiselectFilter"
                  [options]="col.filterOptions.values" defaultLabel=""
                  (onChange)="updateTableFilter(col.field, $event.value, 'in', col.filterChars)"
                  [(ngModel)]="filter.search[col.field]"
                  (keyup.enter)="globalFilterChange($event.target.value)"></p-multiSelect>
                <!-- Filtro Data -->
                <div [attr.data-testid]="'filter_for_' + col.field" *ngSwitchCase="dateFilter">
                  <p-calendar *ngIf="srvCalendar.pcalendarTranslate" class="calendarKontable" dataType="date"
                    dateFormat="{{srvCalendar.pcalendarTranslate.dateFormat}}" [(ngModel)]="filter.search[col.field]"
                    [monthNavigator]="true" [yearNavigator]="true" [locale]="srvCalendar.pcalendarTranslate"
                    [yearRange]="'1900:2099'"
                    (onSelect)="updateTableFilter(col.field, convertDate($event), 'equals', col.filterChars)"
                    (onClearClick)="updateTableFilter(col.field, $event.value, 'equals', col.filterChars)"
                    [inputStyle]="{'width':'100%', 'height':'26px', 'border-color':'#fec55c'}" [readonlyInput]="true"
                    showClear="true" showButtonBar="true" (keyup.enter)="globalFilterChange($event.target.value)"
                    (keyup.delete)="clearDateFilter(col.field)">
                  </p-calendar>
                </div>
                <span [attr.data-testid]="'filter_for_' + col.field" *ngSwitchCase="customFilter">
                  <ng-container *ngTemplateOutlet="col.filterTemplate; context: {$implicit:col}"></ng-container>
                </span>
                <span *ngSwitchDefault>&nbsp;</span>
              </div>
            </div>

          </th>
          <th id="filter-buttons-container" *ngIf="showResetFiltersBtn || !filterBySingleColumn || showRowButtons">

            <!-- Button Pulisci Filtri -->
            <button *ngIf="showResetFiltersBtn" data-testid="refreshFilter" id="refreshFilter" name="refreshFilter"
              pButton type="button" class="k-generic-btn" (click)="clearFilters()" icon="fa fa-refresh" iconPos="center"
              pTooltip="{{ 'kontable.clearFilters' | translate }}">
            </button>

            <!-- Button Applica Filtri -->
            <button *ngIf="!filterBySingleColumn" data-testid="applyFilter" pButton type="button" class="k-generic-btn"
              (click)="updateTableFilter(null, null, null, 1, 1000, true)" icon="fa fa-filter" iconPos="center"
              pTooltip="{{ 'kontable.applyFilters' | translate }}">
            </button>

          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row let-columns="columns" let-index="rowIndex">
        <tr [ngClass]="{'odd-row':alternateRows && index%2==0,'rowHover': allowSelectRow || showSelectButton}" class="kontable-tr
        {{ row.flg_state && row.flg_state == '1' ? 'deleted-row' : '' }}
        {{ row.flg_state && row.flg_state == '2' ? 'status2-row' : '' }}
        {{ row.flg_state && row.flg_state == '3' ? 'status3-row' : '' }}
        {{ row.customerCardState && row.customerCardState == '7' ? 'customerCardState7-row' : '' }}
       {{ row.cardLinkStatus && row.cardLinkStatus == '7' ? 'status-row' : '' }}">

          <!-- Open Record -->
          <td *ngIf="expandTable">

            <div class="row-opener">
              <button pToolTip="Open Record" data-testid-generic="actionDetailButton"
                [attr.data-testid]="'actionDetailButton' + row.id" class="roundedButton" (click)="onExpandRow(row)">
                <i [ngClass]="{
                  'fa-chevron-right': currentOpenedRow !== row.id && currentOpenedRow !== row.distributionListId,
                  'fa-chevron-down': currentOpenedRow === row.id || currentOpenedRow === row.distributionListId
                }" class="fa"></i>
              </button>
            </div>
          </td>

          <td [attr.data-testid-generic]="'selectRowCheckBox'" [attr.data-testid]="'selectRowCheckBox' + row.id"
            class="allowSelectCheckbox" *ngIf="showSelectButton && row.id" (click)="onClickRow(index,row,$event)">
            <p-checkbox class="ch-checkbox" [disabled]="true" [binary]="true" [(ngModel)]="row.rowSelected"
              (onChange)="onSelect(row)">
            </p-checkbox>
          </td>

          <td [attr.data-testid-generic]="'selectBasketRowCheckBox'"
            [attr.data-testid]="'selectBasketRowCheckBox' + row.basketId" class="allowSelectCheckbox"
            *ngIf="showSelectButton && row.basketId" (click)="onClickRow(index,row,$event)">
            <p-checkbox class="ch-checkbox" [disabled]="true" [binary]="true" [(ngModel)]="row.rowSelected"
              (onChange)="onSelect(row)">
            </p-checkbox>
          </td>

          <td *ngFor="let col of columns" [ngStyle]="{'text-align': col.textAlignment ? col.textAlignment : 'left'}"
            (click)="onClickRow(index,row,$event)">
            <span *ngIf="col.bodyTemplate">
              <ng-container
                *ngTemplateOutlet="col.bodyTemplate; context: {$implicit:row, value: row[col.field]}"></ng-container>
            </span>
            <span *ngIf="!col.bodyTemplate">
              <span *ngIf="col.type && col.type == 'date'">
                <span *ngIf="!srvCalendar.checkDateFormat(row[col.field])">{{ row[col.field] | date:
                  srvCalendar.pcalendarTranslate.dateFormatFilter }}</span>
                <span *ngIf="srvCalendar.checkDateFormat(row[col.field])">{{ row[col.field] }}</span>
              </span>
              <span *ngIf="col.type && col.type !== '' && col.type !== 'date'">{{format(row[col.field],
                col.type)}}</span>
            </span>
          </td>

          <td>
            <!-- Giusto per riempire la riga, soluzione temporanea -->
          </td>
        <!-- Gestione normale per ID=riga della tabella -->
        <tr *ngIf="loadedActionTable && row.id === currentOpenedRow">
          <td [attr.colspan]="cols.length + 2" class="action-detail-row">
            <div style="width: 100% !important;">
              <!-- Contenuto della nuova riga -->
              <app-action-table3 [campaign]="row" [actionData]="campaignActions"
                (refreshCampaignActions)="fetchCampaignActions(row)"></app-action-table3>
            </div>
          </td>
        </tr>

        <!-- Gestione delle sfide -->
        <tr *ngIf="loadedChallengeTable && row.id === currentOpenedRow">
          <td [attr.colspan]="cols.length + 2" class="action-detail-row">
            <div style="width: 100% !important;">
              <ng-container
                *ngTemplateOutlet="customExpandedRowTemplate ? customExpandedRowTemplate : defaultExpandedRowTemplate;
              context: { challengeDetailList: challengeDetailList, challengeDetailListElaborated:challengeDetailListElaborated, $implicit: row }">
              </ng-container>
            </div>
          </td>
        </tr>


      </ng-template>
      <ng-template pTemplate="paginatorleft" let-state>
        <p data-testid="totalRecords" class="paginator-total-records" *ngIf="showTotalRecord">{{
          'kontable.total_records' | translate }}:
          {{totalRecords}}</p>
      </ng-template>
      <ng-template data-testid="totalPages" pTemplate="paginatorright" let-state>
        <p class="paginator-total-records" *ngIf="showTotalPages">{{ 'kontable.total_pages' | translate }}:
          {{totalPages}}</p>
      </ng-template>
    </p-table>

    <p-dialog *ngIf="showInfo" [width]="500" [height]="200" [(visible)]="showInfo"
      header="{{ 'kontable.recordInfoTitle' | translate }}" [responsive]="true" showEffect="fade" [modal]="true">

      <ng-container *ngTemplateOutlet="infoDialogBodyTemplate ? infoDialogBodyTemplate: defaultInfoContent">
      </ng-container>

      <div class="ui-dialog-footer">
        <p-button id="closeInfo" name="closeInfo" styleClass="slim blue-button" label="Close"
          (onClick)="showInfo = false;"></p-button>
      </div>
    </p-dialog>

    <ng-template #defaultInfoContent>
      <div>

        <div class="ui-g ui-fluid" *ngIf="currentInfo && currentInfo.userInsertInfo">
          <div class="ui-g-6">
            <label>{{ 'kontable.insertedBy' | translate }}</label>
            <span>{{ currentInfo.userInsertInfo.login }}</span>
          </div>
          <div class="ui-g-6">
            <label>{{ 'kontable.insertedOn' | translate }}</label>
            <span>{{ currentInfo.userInsertInfo.insert_timestamp | date :'dd/MM/yyyy hh:mm:ss' }}</span>
          </div>
        </div>

        <div class="ui-g ui-fluid" *ngIf="currentInfo && currentInfo.userUpdateInfo">
          <div class="ui-g-6">
            <label>{{ 'kontable.updatedBy' | translate }}</label>
            <span>{{ currentInfo.userUpdateInfo.login }}</span>
          </div>
          <div class="ui-g-6">
            <label>{{ 'kontable.updatedOn' | translate }}</label>
            <span>{{ currentInfo.userUpdateInfo.update_timestamp | date :'dd/MM/yyyy hh:mm:ss' }}</span>
          </div>
        </div>

        <div class="ui-g ui-fluid" *ngIf="currentInfo && currentInfo.userDeleteInfo">
          <div class="ui-g-6">
            <label>{{ 'kontable.deletedBy' | translate }}</label>
            <span>{{ currentInfo.userDeleteInfo.login }}</span>
          </div>
          <div class="ui-g-6">
            <label>{{ 'kontable.deletedOn' | translate }}</label>
            <span>{{ currentInfo.userDeleteInfo.delete_timestamp | date :'dd/MM/yyyy hh:mm:ss' }}</span>
          </div>
        </div>

        <div class="ui-g ui-fluid" *ngIf="!currentInfo">
          <div class="ui-g-6">
            <label>{{ 'kontable.insertedBy' | translate }}</label>
            <span>{{ 'kontable.unknownUser' | translate }}</span>
          </div>
        </div>

      </div>
    </ng-template>

  </div>

</div>


// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/challenge/challenge-3-kontable/challenge-3-kontable.component.html